<template>
  <!-- <div> -->
  <vs-card>
    <div class="worker">
        <div class="title">

      <vs-icon icon="apartment"></vs-icon>
      <h3>Total Worker Today</h3>
        </div>
      <br />
      <p>There are {{ $store.getters['i_APC/numWorker'] }} employees working today.</p>
    </div>
  </vs-card>
  <!-- </div> -->
</template>

<script>
export default {
  props:{
  },
  data() {
    return {
      // numWorker: 50,
    };
  },
};
</script>

<style lang="scss" scoped>
.worker {
  // background-color: aqua;
  // width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .title{
      display: flex;
      gap: 10px;

  }
  p {
    margin: 0;
    font-size: 1rem;
  }
}
</style>